import { TranslationContext } from 'contexts/translation-context';

import { useContext } from 'react';
import styled from 'styled-components';

const MobileWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const MobileContent = styled.div`
  width: calc(100% - 24px);
  max-width: 680px;
  margin: 0 12px;
  padding: 28px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.siteCardBorder};
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
`;
const MobileTitle = styled.div`
  font-family: ${props => props.theme.fonts.FunnelDisplay};
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  color: ${props => props.theme.colors.black};
  text-align: center;
  margin: 0 0 14px;
`;
const MobileSubtitle = styled.div`
  font-family: ${props => props.theme.fonts.interSans};
  font-size: 15px;
  color: ${props => props.theme.colors.siteBlack};
  text-align: center;
  line-height: 1.5;
  margin-bottom: 22px;
`;
const MobileWhiteBox = styled.div`
  background: ${props => props.theme.colors.white};
  border-radius: 14px;
  border: 1px solid ${props => props.theme.colors.siteCardBorder};
  padding: 22px 18px;
  margin-bottom: 22px;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;
const MobileListTitle = styled.div`
  font-family: ${props => props.theme.fonts.interSansSemiBold};
  font-size: 15px;
  line-height: 1.45;
  color: ${props => props.theme.colors.black};
  margin-bottom: 14px;
`;
const MobileList = styled.ul`
  padding-left: 20px;
  margin: 0 0 12px 0;
  font-size: 13px;
  color: ${props => props.theme.colors.siteBlack};
  font-family: ${props => props.theme.fonts.interSans};

  ::marker {
    color: ${props => props.theme.colors.siteIndigo};
  }
`;
const MobileListItem = styled.li`
  margin-bottom: 12px;
  line-height: 1.5;

  &::marker {
    color: ${props => props.theme.colors.siteIndigo};
  }

  b {
    font-family: ${props => props.theme.fonts.interSansSemiBold};
    color: ${props => props.theme.colors.black};
  }
`;
const MobileEmailSection = styled.div`
  font-size: 13px;
  color: ${props => props.theme.colors.siteBlack};
  font-family: ${props => props.theme.fonts.interSans};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
const MobileEmail = styled.a`
  color: ${props => props.theme.colors.siteIndigo};
  font-family: ${props => props.theme.fonts.interSansSemiBold};
  font-size: 13px;
  word-break: break-all;
  margin-top: 2px;
`;
const MobileDivider = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.lightGrey};
  margin: 0 0 22px;
  width: 100%;
`;
const MobileText = styled.div`
  color: ${props => props.theme.colors.siteBlack};
  font-size: 13px;
  line-height: 1.7;
  text-align: center;
  font-family: ${props => props.theme.fonts.interSans};
`;
const MobileContact = styled.span`
  color: ${props => props.theme.colors.siteIndigo};
  font-family: ${props => props.theme.fonts.interSansSemiBold};
  font-size: 13px;
  cursor: pointer;
`;

export const SuccessPageMobile = () => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };
  const handleContactUsClick = () => {
    window.open('https://www.rapnet.com/contact/support/', '_blank');
  };
  return (
    <MobileWrapper>
      <MobileContent>
        <MobileTitle>{TRANSLATION_TEXT.thank_you_for_subscribing}</MobileTitle>
        <MobileSubtitle>{TRANSLATION_TEXT.process_your_rapnet_membership}</MobileSubtitle>
        <MobileWhiteBox>
          <MobileListTitle>We require these documents:</MobileListTitle>
          <MobileList>
            <MobileListItem>
              <b>Active Business License / Certificate of Incorporation</b>
              <br />
              Confirming your involvement in the diamond or jewelry trade.
            </MobileListItem>
            <MobileListItem>
              <b>Government-issued Photo ID</b>
              <br />
              Required for the company owner and employees needing Rapaport Trade access.
            </MobileListItem>
            <MobileListItem>
              <b>Trade Reputation & Industry Affiliation</b>
              <ul style={{ paddingLeft: 16, margin: 0 }}>
                <li>
                  <b>Two Trade References</b> - From diamond or jewelry companies you've worked with
                  in the last 6 months (client for at least 1 year).
                </li>
                <li>
                  <b>Two Trade Invoices</b> - Dated within the last 6 months.
                </li>
              </ul>
            </MobileListItem>
          </MobileList>
          <MobileEmailSection>
            <div>Please email these documents to</div>
            <MobileEmail href="mailto:compliance@rapaport.com">compliance@rapaport.com</MobileEmail>
          </MobileEmailSection>
        </MobileWhiteBox>
        <MobileDivider />
        <MobileText>
          <div>
            A Rapaport representative will follow up with you within 48 hours to process your
            membership.
            <br />
            Your subscription will be activated once all documents are approved, and payment has
            been received.
          </div>
          <div style={{ marginTop: 10 }}>
            If you have any questions, please feel free to{' '}
            <MobileContact onClick={handleContactUsClick}>contact us</MobileContact>.
          </div>
        </MobileText>
      </MobileContent>
    </MobileWrapper>
  );
};
